module.exports = __webpack_public_path__ + "static/media/BVP_Logo.61140565.png";